import { ISpotlightSection } from "@/interfaces/spotlight";
import { BasicButton, LoadingSpinner } from "thrive-components";



const SpotlightSection = ({isLoading, item} :ISpotlightSection ) => {   
    if (isLoading) return (<LoadingSpinner size={24} />)
    if (!item) return null;
    
    const {image, title, link, body} = item;

    return (
        <div className="spotlight-section thrive-panel">
            <div className="spotlight-information">
                <h2>{title}</h2>
                <span>{body}</span>
            </div>

            <div className="spotlight-image-wrapper">
                <img
                    src={image?.uri}
                    className="spotlight-image"
                    alt={title}
                />
            </div>

            {link.text &&
                <BasicButton 
                    className="spotlight-button-link" 
                    content={`${link.text} →`} 
                    isLink 
                    linkUrl={link?.uri} 
                    ariaLabel={link?.label ?? "Open link"} 
                    openInNewTab
                />
            }
        </div>
    );
}

export default SpotlightSection